<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('toolhead_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-tools</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <br />
    <div v-if="item" class="table-toolhead-show">
      <v-img
        class = "ma-2"
        max-height="250"
        max-width="250"
        lazy-src="@/assets/imagenotfound.png"
        :key="componentKey"
        :src="imageurlItem"
      >
        <ImageForm
          ref="updateForm"
          :item="item"
          v-if="userHasAccess('toolhead_edit')"
        />
          <v-btn
            color="secondary"
            small
            absolute
            bottom
            right
            @click="downloadItem()"
          >
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
      </v-img>
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('profile.tool.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('profile.tool.version') }}</strong></td>
              <td>
                                    {{ item['version'] }}
              </td>
            </tr>

            <tr>
              <td><strong>{{ $t('profile.tool.parent') }}</strong></td>
              <td>
                                    <span v-if="item['parent']">{{ item['parent'].name }}</span>
              </td>
              <td></td>
              <td>

              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('profile.machine.machine') }}</strong></td>
              <td>
                  <ul v-for="(object, attr) in item['machine']" :key="attr">
                    <li>
                      <span ><router-link class="routerLink" :to="{ name: 'MachineShow', params: { id:  object['@id']}  }">{{ object.name }}</router-link></span>
                    </li>
                  </ul>
              </td>
              <td><strong>{{ $t('profile.setupdefinition.materialsupply') }}</strong></td>
              <td>
                  <ul v-for="(object, attr) in item['materialSupply']" :key="attr">
                    <li>
                      <span ><router-link class="routerLink" :to="{ name: 'MaterialSupplyShow', params: { id:  object['@id']}  }">{{ object.name }}</router-link></span>
                    </li>
                  </ul>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('global.archive') }}</strong></td>
              <td>
                                    {{ item['archive'] }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <template>
        <div class="toolheadsub-list">
          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex sm12 >
                <h2>{{$t('profile.tool.toolheadssub')}}</h2>
              </v-flex>
              <v-flex lg12>
                <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
                  <ToolHeadSubFilterForm
                    ref="filterForm"
                    :values="filters"
                    slot="filter"
                  />
                </DataFilter>

                <br />

                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="items"
                  :loading="isLoading"
                  :loading-text="$t('global.loading')"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  class="elevation-1"
                  item-key="@id"
                  @update:options="onUpdateOptions"
@click:row="showHandlerSubEvent"
                >
                      <template slot="item.inputQuantity" slot-scope="{ item }">
                        {{ $n(item['inputQuantity']) }}
                      </template>
                      <template slot="item.outputQuantity" slot-scope="{ item }">
                        {{ $n(item['outputQuantity']) }}
                      </template>
                      <template slot="item.tools" slot-scope="{ item }">
                        <ul>
                          <li v-for="tool in item['tools']" :key="tool.id">
                            {{ tool.name }}
                          </li>
                        </ul>
                      </template>

                      <ActionCell
                      slot="item.action"
                      slot-scope="props"
                      :handle-show="() => showHandlerSub(item,'ToolHeadSub',props.item)"
                      ></ActionCell>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>

    </div>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <ProducttypefileList v-if="item"
            ref="ProducttypefileList"
            :toolHeadParent="[item['@id']]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="12">
            <div v-if="changeLog" class="table-changelog-show">
              <br />
              <Toolbar :handle-edit="() => editSubHandler(changeLog,'ChangeLog')" :hasAccess="userHasAccess('changelog_edit')" >
                <template slot="left">
                  <v-toolbar-title class="hidden-md-and-down">
                    <h1><v-icon large>mdi-math-log</v-icon>{{ $t('version.changelog.changelog') }}</h1>
                  </v-toolbar-title>
                </template>
              </Toolbar>

              <br />
              <v-simple-table>
                <template slot="default">
                  <thead>
                    <tr>
                      <th>{{ $t('global.field') }}</th>
                      <th>{{ $t('global.value') }}</th>

                      <th>{{ $t('global.field') }}</th>
                      <th>{{ $t('global.value') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><strong>{{ $t('version.changelog.name') }}</strong></td>
                      <td>
                                            {{ changeLog['name'] }}
                      </td>

                    <tr>
              <td><strong>{{ $t('version.changelog.newfeatures') }}</strong></td>
              <td>
                <span  class="tablehtmleditor" v-html="item['changeLog'].newFeatures"></span>
              </td>

              <td><strong>{{ $t('version.changelog.bugfixes') }}</strong></td>
              <td>
                  <span  class="tablehtmleditor" v-html="item['changeLog'].bugFixes"></span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('version.changelog.knownbugs') }}</strong></td>
              <td>
                   <span  class="tablehtmleditor" v-html="item['changeLog'].knownBugs"></span>
              </td>

              <td><strong>{{ $t('version.changelog.notes') }}</strong></td>
              <td>
                  <span  class="tablehtmleditor" v-html="item['changeLog'].notes"></span>
              </td>
            </tr>
                    <tr>
                      <td><strong>{{ $t('version.changelog.developexternal') }}</strong></td>
                      <td>
                                            {{ changeLog['developExternal'] }}
                      </td>

                      <td><strong>{{ $t('version.changelog.developer') }}</strong></td>
                      <td>
                                  <span v-if="changeLog['developer']">{{ changeLog['developer'].login }}</span>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>{{ $t('version.changelog.start') }}</strong></td>
                      <td>
                                {{ formatDate(changeLog['start'], 'long') }}
                      </td>

                      <td><strong>{{ $t('version.changelog.end') }}</strong></td>
                      <td>
                                  {{ formatDate(changeLog['end'], 'long') }}
                      </td>
                    </tr>

                  </tbody>
                </template>
              </v-simple-table>
            </div>
          </v-col>
        </v-row>
      </v-container>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions,mapState, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ToolHeadSubFilterForm from '../../components/toolheadsub/Filter';
import DataFilter from '../../components/DataFilter';
import ImageForm from '../../components/ImageForm.vue';
import FileMixin from '../../mixins/FileMixin';
import ProducttypefileList from '../producttypefile/List';

export default {
  name: 'ToolHeadShow',
  servicePrefix: 'ToolHead',
  components: {
      Loading,
      Toolbar,
      ActionCell,
      ToolHeadSubFilterForm,
      DataFilter,
      ImageForm,
      ProducttypefileList
  },
  mixins: [ListMixin,ShowMixin,AccessMixin,FileMixin],
  computed: {
    //...mapGetters('toolhead', ['find']),
    ...mapGetters('toolhead', {
      find: 'find'
    }),
    ...mapGetters('toolheadsub', {
      items: 'list'
    }),
    ...mapFields('toolheadsub', {
      isLoading: 'isLoading'
    }),
    ...mapFields('toolheadsub', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    ...mapGetters('toolhead',{
      dataToolhead: 'data',
    }),
    ...mapState('toolhead', {
      updatedata: 'updatedata',
      error: 'error',
      isLoading: 'isLoading',
    }),
    changeLog: {
      get() { return this.changeLogData },
       set(value) { this.changeLogData = value; }
    }
  },
  data() {
    return {
      filter: '250x250',
      headers: [
        { text: this.$t('profile.tool.inputquantity'), value: 'inputQuantity' },
        { text: this.$t('profile.tool.outputquantity'), value: 'outputQuantity' },
        { text: this.$t('profile.tool.heater'), value: 'heater' },
        { text: this.$t('profile.tool.model'), value: 'model' },
        { text: this.$t('profile.tool.optionsubtool'), value: 'optionSubTool' },
        { text: this.$t('profile.tool.materialmedium'), value: 'materialMedium.name' },
        { text: this.$t('profile.tool.materialfeedspec'), value: 'materialFeedSpec.name' },
        { text: this.$t('profile.tool.nozzletype'), value: 'nozzleType.name' },
        { text: this.$t('profile.tool.tools'), value: 'tools' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'toolHead' : this.$route.params.id,
      //  ...mapGetters('toolhead', { 'toolHead.id': 'find' }),
      },
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      changeLogData: null,
    };
  },
  methods: {
    ...mapActions('toolhead', {
      deleteItem: 'del',
      update: 'update',
      reset: 'reset',
      retrieve: 'load'
    }),
    ...mapActions('toolheadsub', {
      getPage: 'fetchAll',
    }),
    ...mapActions({
      toolheadGetSubItem: 'toolhead/subItem'
    }),
    showHandlerSubEvent(value) {
      this.showHandlerSub(this.item,'ToolHeadSub',value);
    }
  },
  watch: {
    updatedata: function (updatedata) {
      if (this.item) {
        if (updatedata == this.item['@id']+ '/'+ 'change_log') {
          this.changeLog = this.dataToolhead(this.item['@id']+ '/'+ 'change_log');
        }
      }
    },
    item: function (item) {

      if(item) {
        if (! this.dataToolhead(item['@id']+ '/'+ 'change_log')) {
          this.toolheadGetSubItem({id: item['@id'], data: 'change_log'});
        } else {
          this.changeLog = this.dataToolhead(this.item['@id']+ '/'+ 'change_log');
        }
      }
    }
  }
};
</script>
